export const mtf = {
	mtfColumns(frameSize: number) {
		const minColumnWidth = 280;
		return Math.max(1, Math.floor(frameSize / minColumnWidth));
	},
};
